module.exports = __webpack_public_path__ + "img/FR16906.8e3755a1.svg";